export default __webpack_public_path__ + "static/media/p9_m.8d9deab4.png";